const config = {
  baseUrl: "/",
  imageUrl: "https://apis-orders-staging.fastenerwarehouse.com.au/api/uploads",
  apiUrl: "https://apis-orders-staging.fastenerwarehouse.com.au/api",
  QrtoCartUrl: "https://orders-staging.fastenerwarehouse.com.au/cart",  
  superAdmin: 1,
  role_admin: 1,
  role_telemkt: 2,
  tiered_free_group: 9,
  days_since_registration: 60,
  paging_size: 20,
};
export default config;
